// Fetch list

export const FETCH = 'serviceWorkers.FETCH'
export const FETCH_STARTED = 'serviceWorkers.FETCH_STARTED'
export const FETCH_FULFILLED = 'serviceWorkers.FETCH_FULFILLED'
export const FETCH_REJECTED = 'serviceWorkers.FETCH_REJECTED'
export const FETCH_CANCELLED = 'serviceWorkers.FETCH_CANCELLED'

export const SORTING_CHANGED = 'serviceWorkers.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'serviceWorkers.FETCH_ONE'
export const FETCH_ONE_STARTED = 'serviceWorkers.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'serviceWorkers.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'serviceWorkers.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'serviceWorkers.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'serviceWorkers.SAVE'
export const SAVE_STARTED = 'serviceWorkers.SAVE_STARTED'
export const SAVE_FULFILLED = 'serviceWorkers.SAVE_FULFILLED'
export const SAVE_REJECTED = 'serviceWorkers.SAVE_REJECTED'
export const SAVE_CANCELLED = 'serviceWorkers.SAVE_CANCELLED'

// Delete

export const DELETE = 'serviceWorkers.DELETE'
export const DELETE_STARTED = 'serviceWorkers.DELETE_STARTED'
export const DELETE_FULFILLED = 'serviceWorkers.DELETE_FULFILLED'
export const DELETE_REJECTED = 'serviceWorkers.DELETE_REJECTED'
export const DELETE_CANCELLED = 'serviceWorkers.DELETE_CANCELLED'

// Export

export const EXPORT = 'serviceWorkers.EXPORT'
export const EXPORT_FULFILLED = 'serviceWorkers.EXPORT_FULFILLED'
